import { render, staticRenderFns } from "./SetPromotionOne.vue?vue&type=template&id=73a6cba8&scoped=true"
import script from "./SetPromotionOne.vue?vue&type=script&lang=js"
export * from "./SetPromotionOne.vue?vue&type=script&lang=js"
import style0 from "./SetPromotionOne.vue?vue&type=style&index=0&id=73a6cba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6cba8",
  null
  
)

export default component.exports